import { useState } from 'react';
import { motion } from 'framer-motion';
import AnimatedSection from '../common/AnimatedSection';

const categories = ['All', 'Banking', 'Technology', 'Finance', 'Education'];

// const courses = [
//   {
//     category: 'Banking',
//     title: 'Advanced Risk Management',
//     duration: '12 Weeks',
//     level: 'Advanced',
//     students: '1.2K+',
//     description: 'Master risk identification, assessment, and mitigation strategies in modern banking.',
//     icon: (
//       <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
//         <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
//       </svg>
//     ),
//   },
//   {
//     category: 'Technology',
//     title: 'Cloud Architecture & DevOps',
//     duration: '10 Weeks',
//     level: 'Intermediate',
//     students: '950+',
//     description: 'Build scalable cloud infrastructure and implement CI/CD pipelines.',
//     icon: (
//       <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
//         <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 15a4.5 4.5 0 0 0 4.5 4.5H18a3.75 3.75 0 0 0 1.332-7.257 3 3 0 0 0-3.758-3.848 5.25 5.25 0 0 0-10.233 2.33A4.502 4.502 0 0 0 2.25 15Z" />
//       </svg>
//     ),
//   },
//   {
//     category: 'Finance',
//     title: 'Financial Modeling & Analysis',
//     duration: '8 Weeks',
//     level: 'Intermediate',
//     students: '800+',
//     description: 'Create sophisticated financial models for business valuation and forecasting.',
//     icon: (
//       <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
//         <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z" />
//       </svg>
//     ),
//   },
//   {
//     category: 'Technology',
//     title: 'Cybersecurity Fundamentals',
//     duration: '10 Weeks',
//     level: 'Beginner',
//     students: '1.5K+',
//     description: 'Learn essential cybersecurity principles, threat detection, and defense strategies.',
//     icon: (
//       <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
//         <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
//       </svg>
//     ),
//   },
//   {
//     category: 'Education',
//     title: 'Digital Curriculum Design',
//     duration: '6 Weeks',
//     level: 'Intermediate',
//     students: '600+',
//     description: 'Design effective digital-first curricula for modern learning environments.',
//     icon: (
//       <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
//         <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25" />
//       </svg>
//     ),
//   },
//   {
//     category: 'Banking',
//     title: 'Regulatory Compliance',
//     duration: '8 Weeks',
//     level: 'Advanced',
//     students: '700+',
//     description: 'Navigate complex regulatory frameworks including AML, KYC, and Basel requirements.',
//     icon: (
//       <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
//         <path strokeLinecap="round" strokeLinejoin="round" d="M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 0 1 9 9v.375M10.125 2.25A3.375 3.375 0 0 1 13.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 0 1 3.375 3.375M9 15l2.25 2.25L15 12" />
//       </svg>
//     ),
//   },
// ];

// const levelColors = {
//   Beginner: 'bg-primary/[0.08] text-primary/70',
//   Intermediate: 'bg-primary/10 text-primary/80',
//   Advanced: 'bg-primary/15 text-primary',
// };

const CourseCard = ({ course, index }) => {
  return (
    <AnimatedSection delay={index * 0.08}>
      <motion.div
        whileHover={{ y: -4 }}
        transition={{ duration: 0.25 }}
        className="group relative bg-white rounded-2xl border border-dark/[0.04] hover:border-primary/15 hover:shadow-xl hover:shadow-primary/[0.06] transition-all duration-500 h-full flex flex-col overflow-hidden"
      >
        <div className="p-7 flex-grow">
          <div className="flex items-center justify-between mb-5">
            {/* <div className="w-10 h-10 rounded-xl bg-primary/[0.06] text-primary flex items-center justify-center group-hover:bg-primary group-hover:text-white transition-all duration-300">
              {course.icon}
            </div> */}
            <span className={`px-2.5 py-1 text-[10px] font-bold rounded-full uppercase tracking-wider bg-primary/[0.08] text-primary/70`}>
              {course?.level}
            </span>
          </div>

          <span className="text-[11px] font-bold text-primary/60 uppercase tracking-widest">
            {course.category_name}
          </span>

          <h3 className="mt-2 text-lg font-bold text-dark group-hover:text-primary transition-colors duration-300 leading-snug">
            {course.title}
          </h3>

          <p
          dangerouslySetInnerHTML={{
            __html: course?.description,
          }} 
          className="mt-3 text-sm text-dark/40 leading-relaxed">
          </p>
        </div>

        <div className="px-7 py-5 border-t border-dark/[0.04] flex items-center justify-between bg-dark/[0.01]">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-1.5 text-xs text-dark/35">
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
              {course?.duration_weeks} Weeks
            </div>
            <div className="flex items-center gap-1.5 text-xs text-dark/35">
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
              </svg>
              {course?.total_students}+ 
            </div>
          </div>
          <span className="text-xs font-semibold text-primary opacity-0 group-hover:opacity-100 transition-all duration-300 flex items-center gap-1">
            Enroll
            <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
            </svg>
          </span>
        </div>
      </motion.div>
    </AnimatedSection>
  );
};

const Courses = ({data}) => {
  const [active, setActive] = useState('All');
  const filtered = active === 'All' ? data : data.filter((c) => c.category_name === active);

  return (
    <section id="courses" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <AnimatedSection>
          <div className="text-center mb-6">
            <span className="inline-block px-4 py-1.5 bg-primary/[0.06] text-primary text-xs font-bold rounded-full tracking-widest uppercase">
              Our Programs
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-dark text-center leading-tight tracking-tight">
            Explore our <span className="text-primary">courses</span>
          </h2>
          <p className="mt-5 text-lg text-dark/45 text-center max-w-xl mx-auto">
            Professional programs designed to accelerate your career in today's most in-demand fields.
          </p>
        </AnimatedSection>

        <AnimatedSection delay={0.1}>
          <div className="mt-12 flex flex-wrap items-center justify-center gap-2">
            {categories?.map((cat,index) => (
              <button
                key={index}
                onClick={() => setActive(cat)}
                className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 ${
                  active === cat
                    ? 'bg-primary text-white shadow-md shadow-primary/20'
                    : 'bg-dark/[0.03] text-dark/50 hover:bg-primary/[0.07] hover:text-primary'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </AnimatedSection>

        <motion.div
          layout
          className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {filtered?.map((course, i) => (
            <CourseCard key={course.title} course={course} index={i} />
          ))}
        </motion.div>

        <AnimatedSection delay={0.3}>
          <div className="mt-14 text-center">
            <a
              href="#contact"
              className="inline-flex items-center gap-2.5 px-8 py-4 bg-primary text-white font-semibold rounded-xl hover:bg-primary/90 transition-all duration-300 shadow-lg shadow-primary/20 hover:shadow-xl hover:shadow-primary/30 hover:-translate-y-0.5"
            >
              View All 200+ Courses
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
              </svg>
            </a>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default Courses;
